import styles from './ThemeItem.module.scss'
import { TrashIcon } from '@phosphor-icons/react'
import ReactECharts from 'echarts-for-react'
import { CONFIG_OPTIONS, simpleOption } from '../styleConsts'
import { ScoopTheme } from '../../../../../Insights/Style'
import { ScoopText, ScoopButton, ScoopTooltip } from '../../../../../ui'

export const ThemeItem = ({ handleDelete, theme, onClick, selectedTheme, setSelectedProp }) => {
    const getContainerClass = () => {
        const classes = [styles.themeItemContainer]
        if (onClick) classes.push(styles.themeClickable)
        if (onClick && selectedTheme === theme?.themeID) classes.push(styles.previewTheme)
        if (theme?.colorScheme.backgroundColor === '#00000000') {
            classes.push(
                theme?.colorScheme.darkTheme ? styles.transparentDark : styles.transparentLight
            )
        }
        return classes.join(' ')
    }

    return (
        <div className={getContainerClass()} onClick={() => onClick && onClick(theme.themeID)}>
            <div className={styles.themeItemHeader}>
                <ScoopTooltip title={theme ? 'Canvas: ' + theme.canvasName : ''}>
                    <ScoopText className={styles.themeName} noWrap>
                        {!theme?.themeName || theme?.themeName === 'Default theme'
                            ? 'Default theme'
                            : theme?.themeName + ' (' + theme?.canvasName + ')' || 'Default theme'}
                    </ScoopText>
                </ScoopTooltip>
                <div className={styles.themeItemControls}>
                    {onClick &&
                        (selectedTheme === theme?.themeID ? (
                            <ScoopButton
                                className={styles.applyThemeButton}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    setSelectedProp(CONFIG_OPTIONS.MAIN)
                                }}
                            >
                                Apply
                            </ScoopButton>
                        ) : (
                            <button
                                className={styles.deleteButton}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    handleDelete(theme.themeID)
                                }}
                            >
                                <TrashIcon size={18} weight="regular" color="#E50B54" />
                            </button>
                        ))}
                </div>
            </div>
            <div className={styles.themeItemPreview}>
                <ReactECharts
                    option={{
                        ...simpleOption,
                        backgroundColor:
                            theme?.colorScheme.backgroundColor || ScoopTheme.backgroundColor,
                        color: theme?.colorScheme.colors.map((c) => c.val) || ScoopTheme.color,
                    }}
                    style={{
                        height: '100%',
                        width: '100%',
                    }}
                />
            </div>
        </div>
    )
}
